import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';

import { constants } from 'bundles/coursera-plus/utils/courseraPlusUtils';
import { useNaptime } from 'bundles/naptimejs';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import SubscriptionTrialsV1 from 'bundles/naptimejs/resources/subscriptionTrials.v1';
import ProductType from 'bundles/payments/common/ProductType';

type PropsFromCourseraPlusSubscriptionFreeTrials = {
  subscriptionTrials: Array<SubscriptionTrialsV1>;
};

const { COURSERA_PLUS_SUBSCRIPTION_UNDERLYING_PRODUCT_ITEM_ID } = constants;

export const useCourseraPlusSubscriptionFreeTrials = () => {
  const {
    data: { subscriptionTrials },
  } = useNaptime<PropsFromCourseraPlusSubscriptionFreeTrials>(() => {
    const productItemId = COURSERA_PLUS_SUBSCRIPTION_UNDERLYING_PRODUCT_ITEM_ID;

    if (!user.isAuthenticatedUser()) {
      return { subscriptionTrials: [] };
    }
    const { COURSERA_PLUS_SUBSCRIPTION } = ProductType;
    const userId = user.get().id;

    return {
      subscriptionTrials: SubscriptionTrialsV1.finder('findByUserAndUnderlyingProduct', {
        params: {
          userProductItemId: tupleToStringKey([userId, COURSERA_PLUS_SUBSCRIPTION, productItemId]),
        },
      }),
    };
  }, []);

  return {
    userHasCourseraPlusFreeTrial: (subscriptionTrials?.length ?? 0) === 0,
  };
};
